<template>
  <div v-if="topline.length > 0">
    <div class="no-data" v-if="!show && projection">
      Projected number of seats for each party will display once sufficient results are available.
    </div>
    <seats-chart-column
      v-else
      v-for="(party, index) in sortedParties"
      :key="index"
      :item="topline.find(t => t.party === party.match)"
      :party="party"
      :projection="projection">
    </seats-chart-column>
  </div>
</template>

<script>
import { parties } from "@/config";
import { ConfigMixin } from "@/mixins";

import SeatsChartColumn from "./SeatsChartColumn"

const mixins = [ConfigMixin];

export default {
  name: "SeatsChart",
  mixins,
  props: {
    projection: {
      type: Boolean,
      required: false,
      default: false
    },
    topline: {
      type: Array,
      required: true
    }
  },
  components: {
    SeatsChartColumn
  },
  data: () => ({
    parties
  }),
  computed: {
    show () {
      return this.topline[0].show_projection_chart !== "FALSE"
    },
    sortedParties () {
      const items = [...this.parties]
      return items.sort((a, b) => {
        const key = this.projection ?  'overall_seat_projection_21' : 'total_seat_count'
        const partyASeats = this.topline.find(t => t.party === a.match)[key]
        const partyBSeats = this.topline.find(t => t.party === b.match)[key]
        return parseInt(partyBSeats) - parseInt(partyASeats)
      })
    }
  }
}
</script>

<style>
.no-data {
  text-align: center;
  font-size: 14px;
  background: #fafafa;
  padding: 30px 60px;
}
</style>
